import Page from '@admin/components/page'
import TeamToken from '@admin/tokens/team'
import React from 'react'

const hoursToDays = (duration) => {
  const days = Math.floor(duration / (24 * 60)).toString().padStart(2, '0')
  const hours = Math.floor((duration % (24 * 60)) / 60).toString().padStart(2, '0')
  const minutes = Math.floor(duration % 60).toString().padStart(2, '0')
  return `${days}:${hours}:${minutes}`
}

const mapPropsToPage = (props, context) => ({
  title:  `Transitions from ${props.query.from} to ${props.query.to}`,
  access: { rights: { $allOf: ['dashboards:access_app','truevail:access_app'] } },
  collection: {
    endpoint: '/api/admin/dashboards/truevail/transition_durations',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Team)', key: 'team.title', sort: 'team', primary: true, format: (team) => <TeamToken { ...team } /> },
      { label: 't(Duration)', key: 'duration', collapsing: true, align: 'right', format: (team) => hoursToDays(team.duration)}
    ],
    defaultSort: { key: 'days', order: 'asc' },
    empty: {
      svg: 'arrow_right_left',
      title: 't(No Transitions)',
      text: 't(No teams transitioned during this time period)'
    },
    entity: 'transitions',
    onClick: (record) => {
      if(record.type === 'agency') context.router.push(`/admin/truevail/admin/agencies/${record.agency_id}`)
      if(record.type === 'advisor') context.router.push(`/admin/truevail/admin/advisors/${record.advisor_id}`)
      if(record.type === 'supplier') context.router.push(`/admin/truevail/admin/suppliers/${record.supplier_id}`)
    }
  }
})

export default Page(null, mapPropsToPage)
